import * as Yup from "yup";


export const getInitialValues=(type:any,vehicleNumber:any,pcnField:any,locationPcn:any,receivedNoticed:any,offenceType:any,pcnDate:any,selectedPcnNumber:any)=>{
  const initialValues = {
    receivedNoticeThrough:receivedNoticed,
    pcnId: pcnField || selectedPcnNumber,
    NORIssuedDate:"",
    pcnIssueDate:pcnDate,
    location: locationPcn,
    offenceType: offenceType,
    groundReason: "",
    vehicleNumber:vehicleNumber,
    challengeReason: "",
    file: "",
    ...type==="independent-adjudicator" && {
      rejectionCode:""
      }
  };

  return initialValues
}

export const getValidationSchema=(type:any)=>{

 const  validationSchema = Yup.object({

  receivedNoticeThrough: Yup.string()
      .required("Please Select Notice source "),

      pcnId: Yup.string()
      .required("PPCN Number Field Required "),

      pcnIssueDate: Yup.string()
  .required("PPCN Date Field Required "),
  vehicleNumber: Yup.string()
  .required("PPCN Date Field Required ").trim(),

  location: Yup.string()
  .required("Required Field").trim(),
  offenceType: Yup.string()
  .required("Required Field").trim(),

  groundReason: Yup.string()
      .required("Required Field").trim(),

      challengeReason: Yup.string()
    .required("Required Field").trim(),

  file: Yup.string()
  .required("Required Field"),
  ...type==="independent-adjudicator" && {
    rejectionCode: Yup.string()
    .required("Rejection Code  Field Required "),
    }

  });

  return validationSchema
}